import type { PipelineHealthDailyStatistic } from '../clients'

type PipelineHealthStatistic = Omit<
  PipelineHealthDailyStatistic,
  | Extract<keyof PipelineHealthDailyStatistic, `prev_day_${string}`>
  | 'percent_single_source'
  | 'number_single_source'
  | 'number_org_buildings'
>

export const SOURCE_GRADE_METRIC_WEIGHTS: Partial<Record<keyof PipelineHealthStatistic, number>> = {
  units_with_street_address: 1,
  units_with_city: 1,
  units_with_zip_code: 1,
  units_with_lat: 0,
  units_with_lon: 0,
  units_with_floorplan_name: 1,
  units_with_unit_name: 1,
  units_with_availability: 1,
  units_with_price: 1,
  units_with_bed: 1,
  units_with_bath: 1,
  units_with_sqft: 1,
  units_with_images: 0.5,
  units_with_specials: 0.25,
  units_with_price_plans: 0.75,
  units_with_included_services: 0.25,
  units_with_floor: 0.5,
  units_with_building: 0.25,
  units_with_amenities: 0.25,
  units_with_deposit: 0.25
}

const SOURCE_GRADE_WEIGHT_SUM = Object.values(SOURCE_GRADE_METRIC_WEIGHTS).reduce(
  (sum, weight) => sum + (weight ?? 0),
  0
)

export const computeSourceGrade = (row: PipelineHealthStatistic): number => {
  if (row.units_scraped <= 0) {
    return 0
  }
  let weighted = 0
  for (const [field, weight] of Object.entries(SOURCE_GRADE_METRIC_WEIGHTS) as [
    keyof PipelineHealthStatistic,
    number
  ][]) {
    if (!weight) {
      continue
    }
    const metric = row[field]
    if (metric === undefined) {
      console.error(`Missing pipeline health metric for field ${field}`)
      continue
    }
    weighted += Number(metric) * weight
  }
  return weighted / SOURCE_GRADE_WEIGHT_SUM / row.units_scraped
}

export const sourceGradesBySource = (rows: PipelineHealthStatistic[]): Record<string, number> => {
  const grades: Record<string, number> = {}
  for (const row of rows) {
    grades[row.source] = computeSourceGrade(row)
  }
  return grades
}
